import { Component, Input } from '@angular/core';
import { AnalyticsItem } from '@features/customers/models/analytics-item.interface';

@Component({
  selector: 'app-analytics-card',
  templateUrl: './analytics-card.component.html',
  styleUrls: ['./analytics-card.component.scss'],
})
export class AnalyticsCardComponent {
  @Input() item: AnalyticsItem;
}
